export const toDateOnly = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const text = String(value).trim();
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return `${match[1]}-${match[2]}-${match[3]}`;

  const parsed = new Date(text);
  if (Number.isNaN(parsed.getTime())) return "";

  return [
    parsed.getUTCFullYear(),
    String(parsed.getUTCMonth() + 1).padStart(2, "0"),
    String(parsed.getUTCDate()).padStart(2, "0"),
  ].join("-");
};

export const ageFromDateOnly = (value, now = new Date()) => {
  const dateOnly = toDateOnly(value);
  if (!dateOnly) return null;

  const [birthYear, birthMonth, birthDay] = dateOnly.split("-").map(Number);
  const todayParts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Edmonton",
    year: "numeric",
    month: "numeric",
    day: "numeric",
  })
    .formatToParts(now)
    .reduce((parts, part) => {
      if (part.type !== "literal") parts[part.type] = Number(part.value);
      return parts;
    }, {});

  let age = todayParts.year - birthYear;
  if (
    todayParts.month < birthMonth ||
    (todayParts.month === birthMonth && todayParts.day < birthDay)
  ) {
    age -= 1;
  }
  return age;
};
